var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Menu List") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4.8,
    className: "st0",
    width: 30,
    height: 2.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22.8,
    className: "st0",
    width: 30,
    height: 2.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 40.8,
    className: "st0",
    width: 30,
    height: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0 M6,9.6C4,9.6,2.4,8,2.4,6S4,2.4,6,2.4S9.6,4,9.6,6 S8,9.6,6,9.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,18c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S9.3,18,6,18 M6,27.6c-2,0-3.6-1.6-3.6-3.6S4,20.4,6,20.4 S9.6,22,9.6,24S8,27.6,6,27.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6,36c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S9.3,36,6,36 M6,45.6c-2,0-3.6-1.6-3.6-3.6S4,38.4,6,38.4 S9.6,40,9.6,42S8,45.6,6,45.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuList);
export default __webpack_public_path__ + "static/media/menu-list.8221f06eac002980c6671e0b15a22bd0.svg";
export { ForwardRef as ReactComponent };